
import request from '@/utils/request'


/**
 * 新增电站基本信息
 * @param {object} station
 * @returns {Promise<AxiosResponse>}
 */
export function add(station) {
  return request({
    url: '/device/station',
    method: 'post',
    data: station
  })
}


/**
 * 修改电站基本信息
 * @param {object} station
 * @returns {Promise<AxiosResponse>}
 */
export function update(station) {
  return request({
    url: '/device/station',
    method: 'put',
    data: station
  })
}

/**
 * 删除电站基本信息
 * @param {string} stationIds
 * @returns {Promise<AxiosResponse>}
 */

export function del(stationIds) {
  return request({
    url: `/device/station/${stationIds}`,
    method: 'delete',
  })
}

/**
 * 获取电站列表
 * @param {Object} param
 * @param {string} [param.province] 省份
 * @param {string} [param.city] 城市
 * @param {string} [param.name] 电站名称
 * @param {string} [param.commossioningTime] 运营时间范围
 * @param {string} [param.classification] 电站分类
 * @param {string} [param.operationModel] 运营模式
 * @param {string|number} [param.pageNum] 页码 默认1页
 * @param {string|number} [param.pageSize] 每页数量 默认10条
 * @param {string} [param.assetProperty] 资产属性
 * @param {string} [param.investor] 投资方（模糊）
 * @param {string} [param.proprietor] 业主方（模糊）
 * @param {string} [param.channel] 渠道方（模糊）
 * @param {string} [param.status] 电站状态（已投运 / 未投运 / 暂停运营 / 待审核 / 被驳回）
 * @param {number|string} [param.stationState] 电站状态码（0 已投运 / 1 未投运 / 2 暂停运营 / 3 待审核 / 4 被驳回，若后端支持可与 status 二选一）
 * @param {string} [param.projectCode] 项目编码（模糊）
 * @param {string} [param.eBlockModel] 设备型号（eBlock，与型号库 modelNumber 一致）
 * @returns {Promise<AxiosResponse>}
 */
export function list(param) {
  return request({
    url: '/device/station/list',
    method: 'get',
    params: param
  })
}

/**
 * 获取电站基本信息详细信息
 * @param {number|string} stationId 电站id
 * @returns {Promise<AxiosResponse>}
 */
export function detail(stationId) {
  return request({
    url: `/device/station/${stationId}`,
    method: 'get',
  })
}

/**
 * 获取电站名称列表
 * @returns {Promise<AxiosResponse>}
 */
export function nameList() {
  return request({
    url: `/device/station/queryNameList`,
    method: 'get',
  })
}

/**
 * 导入
 * @param {FormData} fd
 * @returns
 */
export function importList(fd) {
  return request({
    url: `/device/station/importData`,
    method: 'post',
    data: fd
  })
}

/**
 * 导出
 * @param {Object} param
 * @param {string} [param.province] 省份
 * @param {string} [param.city] 城市
 * @param {string} [param.name] 电站名称
 * @param {string} [param.commossioningTime] 运营时间范围
 * @param {string} [param.classification] 电站分类
 * @param {string} [param.operationModel] 运营模式
 * @param {string} [param.assetProperty] 资产属性
 * @returns {Promise<AxiosResponse>}
 */
export function exportList(param) {
  return request({
    url: `/device/station/export`,
    method: 'post',
    data: param,
    responseType: 'blob'
  })
}

/**
 * 上传电站图片
 * @param {FormData} fd
 * @param {Blob} fd.stationPicture 电站图片
 * @param {string} fd.province 电站所属省份
 * @returns
 */
export function uploadImage(fd) {
  return request({
    url: `/device/station/upload`,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: fd
  })
}

/**
 * 电站退役
 * @param {*} stationIds
 * @returns
 */
export function changeStationState(stationIds) {
  return request({
    url: `/device/station/changeStationState/${stationIds}`,
    method: 'get',
  })
}

/**
 * 获得模板详情
 * @returns
 */
export function getTemplateList() {
  return request({
    url: `/productmng/template/list`,
    method: 'get',
  })
}

/**
 * 导入资产数据
 * @param {*} file
 * @param {*} onUploadProgress
 * @param {*} updateSupport
 * @returns
 */
export function importAssets(file, onUploadProgress, updateSupport = false) {
  const fd = new FormData()
  fd.append('file', file, file.name)
  fd.append('updateSupport', updateSupport)
  return request({
    url: `/device/station/importStations`,
    method: 'post',
    data: fd,
    onUploadProgress: onUploadProgress,
  })
}

/**
 * 导出资产数据
 * @param {*} stations
 * @param {*} sheets
 * @param {*} exportAll
 * @returns
 */
export function exportAssets(stations, sheets, exportAll) {
  return request({
    url: `/device/station/exportStations`,
    method: 'post',
    data: {
      stations,
      sheets,
      exportAll
    }
  })
}

export function exportStationEfficiency(data) {
  const fd = new FormData()
  Object.entries(data || {}).forEach(([key, value]) => {
    fd.append(key, value)
  })
  return request({
    url: `/device/v2/station1/efficiencyExport`,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: fd,
    responseType: 'blob'
  })
}

export function faultRecordList(stationId, uuid, fileName, pageNum, pageSize) {
  return request({
    url: `/device/fault/record/list`,
    method: 'get',
    params: {
      stationId,
      uuid,
      fileName,
      pageNum,
      pageSize,
    }
  })
}

// v2
// ============================================================================
// ============================================================================

/**
 * 查询电站下的设备
 * @param {*} stationId
 * @returns
 */
export function getDevicesById(stationId) {
  if (!stationId) {
    throw new ReferenceError('电站Id不存在')
  }
  return request({
    url: `/device/v2/station/equipments/${stationId}`,
    method: 'get',
  })
}

/**
 * Retrieves a list of devices by station ID.
 *
 * @param {string} stationId - The ID of the station to retrieve devices from.
 * @throws {ReferenceError} If the station ID does not exist.
 * @return {Promise} A Promise that resolves with the retrieved list of devices.
 */
export function getDevicesByIdV2(stationId) {
  if (!stationId) {
    throw new ReferenceError('电站Id不存在')
  }
  return request({
    url: `/device/v2/station/new/equipments/${stationId}`,
    method: 'get',
  })
}


/**
 * 注册设备
 * @param {*} devices
 * @returns
 */
function registerDevices(devices) {
  return request({
    url: `/device/v2/station/equipments`,
    method: 'put',
    data: devices
  })
}

/**
 * 注册设备
 * @param {*} data
 * @returns
 */
function registerDevicesV2(data) {
  return request({
    url: `/device/v2/station/new/equipments`,
    method: 'put',
    data: data
  })
}

/**
 * 导出eLink配置
 * @param {*} stationUUID 电站ID
 * @param {*} eLinkId elink主键ID
 * @param {*} eBlockNum eBlock数量
 * @param {*} eBlockType eBlock型号
 */
export function exportELinkConfig(stationUUID, eLinkId, eBlockNum, eBlockType) {
  return request({
    url: `/device/v2/station/exportELinkConfig`,
    method: 'get',
    params: {
      stationUUID, eLinkId, eBlockNum, eBlockType
    }
  })
}

/**
 * 参考需量查询接口
 * @param stationId
 * @param pageNum
 * @param pageSize
 * @param demand
 * @returns {*}
 */
export function demandList(stationId, pageNum, pageSize, demand) {
  return request({
    url: '/device/station/demand/list',
    method: 'get',
    params: {
      stationId, pageNum, pageSize, demand
    }
  })
}



export function validateStationUUID(uuid) {
  return request({
    url: 'device/station/queryStationUUID',
    method: 'get',
    params: {
      uuid
    }
  })
}



export const v2 = Object.freeze({
  getDevicesById,
  getDevicesByIdV2,
  registerDevices,
  registerDevicesV2,
})


/**
 * 维护记录查询
 * @param {*} stationId 
 * @param {*} delFlag 1查询未删除，2查询逻辑删除
 * @param {*} id 情况一：查询指定一条记录传参，情况二：如查询多条传参null
 * @param {*} pageNum 
 * @param {*} pageSize 
 * @returns 
 */
export function getMaintainList(stationId, delFlag, id, pageNum, pageSize) {
  return request({
    url: '/device/station/maintain/query',
    method: 'get',
    params: {
      stationId,
      delFlag,
      id,
      pageNum,
      pageSize
    }
  })
}

/**
 * 维护记录新增
 * @param {*} data 
 * @param {*} data.stationId
 * @param {*} data.maintainAction
 * @param {*} data.content
 * @param {*} data.remark
 * @returns 
 */
export function addMaintain(data) {
  return request({
    url: '/device/station/maintain/save',
    method: 'post',
    data
  })
}



// /device/station/maintain/update
/**
 * 维护记录修改
 * @param {*} data 
 * @param {*} data.id
 * @param {*} data.stationId
 * @param {*} data.maintainAction
 * @param {*} data.content
 * @param {*} data.remark
 * @returns 
 */
export function updateMaintain(data) {
  return request({
    url: '/device/station/maintain/update',
    method: 'put',
    data
  })
}


/**
 * 维护记录删除
 * @param {*} id 
 * @returns 
 */
export function delMaintain(id) {
  return request({
    url: `/device/station/maintain/delete`,
    method: 'delete',
    data: { id }
  })
}

// 判断是否有权限
export function getStationStrategyConfig(stationId) {
  return request({
    url: `/device/v2/station/strategy/config/${stationId}`,
    method: 'GET',
  })
}


/**
 * 电站建站审核列表
 * @param {Object} params
 * @param {number} [params.pageNum=1]
 * @param {number} [params.pageSize=10]
 * @param {number} params.stationId
 * @returns
 */
export function getStationApprovalList(params) {
  return request({
    url: '/device/v3/station/approval/station/list',
    method: 'get',
    params,
  })
}

/**
 * 提交电站建站审核申请
 * @param {Object} params
 * @param {number} params.stationId 电站id
 * @returns
 */
export function submitStationApproval(params) {
  return request({
    url: '/device/v3/station/approval/apply',
    method: 'post',
    params,
  })
}

/**
 * 我创建的电站（投运审批）列表
 * @param {Object} params
 * @param {number} [params.pageNum=1] 页码
 * @param {number} [params.pageSize=10] 每页数量
 * @param {string} [params.stationName] 电站名称（模糊查询）
 * @param {number} [params.status] 状态:0待审批 1通过 2驳回
 * @returns
 */
export function getMyStationApprovalList(params) {
  return request({
    url: '/device/v3/station/approval/my/created/station/list',
    method: 'get',
    params,
  })
}

/**
 * 待审批的电站列表（客服运维视角）
 * @param {Object} params
 * @param {number} [params.pageNum=1] 页码
 * @param {number} [params.pageSize=10] 每页数量
 * @param {string} [params.stationName] 电站名称（模糊查询）
 * @returns
 */
export function getTodoStationApprovalList(params) {
  return request({
    url: '/device/v3/station/approval/todo/list',
    method: 'get',
    params,
  })
}

/**
 * 我审批过的电站列表（审批通过 / 已驳回）
 * @param {Object} params
 * @param {number} [params.pageNum=1] 页码
 * @param {number} [params.pageSize=10] 每页数量
 * @param {string} [params.stationName] 电站名称（模糊查询）
 * @param {number} [params.status] 状态:1通过 2驳回
 * @returns
 */
export function getApprovedStationApprovalList(params) {
  return request({
    url: '/device/v3/station/approval/my/approved/station/list',
    method: 'get',
    params,
  })
}

/**
 * 审批电站（投运 / 驳回）
 * @param {Object} data
 * @param {number} data.id 审批记录id
 * @param {boolean} data.pass 是否通过:true通过 false驳回
 * @param {string} [data.remark] 审批意见(<=500字符)
 * @returns
 */
export function approveStationApproval(data) {
  return request({
    url: '/device/v3/station/approval/approve',
    method: 'post',
    data,
  })
}

/**
 * 标记建站审批记录为申请人「已读」
 * 仅申请者视角调用（我创建的电站 / 电站申请卡片工程类角色）：
 * 当审批结果 applicantRead === 0（未读）时，进入详情前调用此接口，
 * 让后端将该条记录置为已读，从而下次不再出现在申请人的未读列表中。
 * @param {number|string} id 审批记录id（列表行 row.id / task.id）
 * @returns
 */
export function markStationApprovalRead(id) {
  return request({
    url: `/device/v3/station/approval/read/${id}`,
    method: 'post',
  })
}


